import { AdLoadingStrategyTypeEnum, AdSizes, AdUnit, AdUnitSpecialUseCaseEnum, AdUnitTypeEnum } from "@repo/lib-domain-tag";
import { pageBidderHelper } from "../pageBidderHelper";
import { deviceUtil } from "@repo/lib-common";

export const desktopLoadMoreAdUnits = [

    //#region loadMore index 1
    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(1)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_masthead_2")
        .setDivId("div-sozcu_gen_lm_masthead_2")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Masthead)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_970x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,


    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(1)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_box_3")
        .setDivId("div-sozcu_gen_lm_box_3")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_GenBodyBox)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    //#endregion

    //#region loadMore index 2

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(2)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_masthead_3")
        .setDivId("div-sozcu_gen_lm_masthead_3")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Masthead)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_970x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,


    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(2)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_box_4")
        .setDivId("div-sozcu_gen_lm_box_4")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_GenBodyBox)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region loadMore index 3

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(3)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_masthead_4")
        .setDivId("div-sozcu_gen_lm_masthead_4")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Masthead)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_970x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,


    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(3)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_box_5")
        .setDivId("div-sozcu_gen_lm_box_5")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_GenBodyBox)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region loadMore index 4

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(4)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_masthead_5")
        .setDivId("div-sozcu_gen_lm_masthead_5")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Masthead)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_970x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,


    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(4)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_box_6")
        .setDivId("div-sozcu_gen_lm_box_6")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_GenBodyBox)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region loadMore index 5

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(5)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_masthead_6")
        .setDivId("div-sozcu_gen_lm_masthead_6")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Masthead)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_970x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,


    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(5)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_box_7")
        .setDivId("div-sozcu_gen_lm_box_7")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_GenBodyBox)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region loadMore index 6

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(6)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_masthead_7")
        .setDivId("div-sozcu_gen_lm_masthead_7")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Masthead)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_970x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(6)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_box_8")
        .setDivId("div-sozcu_gen_lm_box_8")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_GenBodyBox)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region loadMore index 7

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(7)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_masthead_8")
        .setDivId("div-sozcu_gen_lm_masthead_8")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Masthead)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_970x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,


    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(7)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_box_9")
        .setDivId("div-sozcu_gen_lm_box_9")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_GenBodyBox)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region loadMore index 8

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(8)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_masthead_9")
        .setDivId("div-sozcu_gen_lm_masthead_9")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Masthead)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_970x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,


    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(8)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_box_10")
        .setDivId("div-sozcu_gen_lm_box_10")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_GenBodyBox)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region loadMore index 9

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(9)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_masthead_10")
        .setDivId("div-sozcu_gen_lm_masthead_10")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Masthead)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_970x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,


    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(9)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_box_11")
        .setDivId("div-sozcu_gen_lm_box_11")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_GenBodyBox)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,

    //#endregion

    //#region loadMore index 10

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(10)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_masthead_11")
        .setDivId("div-sozcu_gen_lm_masthead_11")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_Masthead)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_970x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,


    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(10)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_gen_lm_box_12")
        .setDivId("div-sozcu_gen_lm_box_12")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.desktop_GenBodyBox)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)

    ,
    //#endregion

];




export const mobileLoadMoreAdUnits = [
    //#region loadMore index 1

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(1)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_m_gen_box_2")
        .setDivId("div-sozcu_m_gen_box_2")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,

    //#endregion

    //#region loadMore index 2

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(2)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_m_gen_box_3")
        .setDivId("div-sozcu_m_gen_box_3")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,

    //#endregion

    //#region loadMore index 3

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(3)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_m_gen_box_4")
        .setDivId("div-sozcu_m_gen_box_4")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,

    //#endregion

    //#region loadMore index 4

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(4)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_m_gen_box_5")
        .setDivId("div-sozcu_m_gen_box_5")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,

    //#endregion

    //#region loadMore index 5

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(5)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_m_gen_box_6")
        .setDivId("div-sozcu_m_gen_box_6")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,

    //#endregion

    //#region loadMore index 6

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(6)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_m_gen_box_7")
        .setDivId("div-sozcu_m_gen_box_7")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,

    //#endregion

    //#region loadMore index 7

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(7)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_m_gen_box_8")
        .setDivId("div-sozcu_m_gen_box_8")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,

    //#endregion

    //#region loadMore index 8

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(8)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_m_gen_box_9")
        .setDivId("div-sozcu_m_gen_box_9")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)

    ,

    //#endregion


    //#region loadMore index 9

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(9)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_m_gen_box_10")
        .setDivId("div-sozcu_m_gen_box_10")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)


    ,
    //#endregion

    //#region loadMore index 10

    AdUnit.builder(AdUnitTypeEnum.banner)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.loadMore)
        .setSpecialUseCaseIndex(10)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_m_gen_box_11")
        .setDivId("div-sozcu_m_gen_box_11")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.mobile_Generic)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(true)
        .setPrebidSizeLimits(AdSizes.prebid_300x250)
        .setBidderHelper(pageBidderHelper)
    //.onSlotRenderEnded(fixPageSkinCssClass)



    //#endregion
];